import { LoginPage } from "./features/auth/LoginPage.tsx"
import { useSession } from "./features/auth/session.ts"
import { Workspace } from "./features/workspace/Workspace.tsx"

export function App() {
  const session = useSession()
  switch (session.status) {
    case "loading":
      return <div className="splash">Loading…</div>
    case "signedOut":
      return <LoginPage />
    case "signedIn":
      return <Workspace user={session.user} />
  }
}
